import { SET_SETTINGS, RESET_SETTINGS } from './SettingsActionTypes'
import { SettingsResponse } from 'types/responses/SettingsResponse'

interface SettingsReducerSetSettingsAction {
    payload: SettingsResponse
    type: typeof SET_SETTINGS
}

interface SettingsReducerResetAction {
    type: typeof RESET_SETTINGS
}

type SettingsReducerAction = SettingsReducerSetSettingsAction | SettingsReducerResetAction

interface SettingsState extends SettingsResponse {}

class SettingsReducer {
    initialState: SettingsState = {
        config: null,
        hall: null,
        liveSegments: null,
        trackLengths: null,
        permissions: null,
        permissionNames: [],
        permissionVisibleNames: [],
        displayAdvertisementTemplate: null,
    } as SettingsState

    reducer = (
        state: SettingsState = this.initialState,
        action: SettingsReducerAction
    ): SettingsState => {
        switch (action.type) {
            case SET_SETTINGS:
                return action.payload
            case RESET_SETTINGS:
                return this.initialState
            default:
                return state
        }
    }
}

export default SettingsReducer
